<template>
  <div class="ui error message">
    <div class="header">Fehler</div>
    <p>{{error.message}}</p>
  </div>
</template>

<script>
export default {
  props: ['error']
}
</script>



// WEBPACK FOOTER //
// error-indicator.vue?e0e565be